import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { sendRequest } from 'src/utils';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Loader from 'src/components/loader/loader';
import { Grid, TextField } from '@mui/material';
import { useState } from 'react';

export default function ReturnDevice({
    loading,
    visible = false,
    setVisible,
    handleDelete,
    title,
    mesages,
    titleButtonConfirm = 'delete',
    typeButtonConfirm = 'delete',
    paramsApi = null,
    serviceApi = null,
    callBackFunct = () => null,
}) {
    const { t } = useTranslation();
    const [flagProcess, setFlagProcess] = useState(false);
    const [noteChange, setNoteChange] = useState('');
    const flagRef = React.useRef(false);

    const handleConfirm = () => {
        if (flagRef.current === true) return;

        if (!noteChange) return toast.error(t('error.param'));

        flagRef.current = true;
        setFlagProcess(true);
        sendRequest(serviceApi, [...paramsApi, noteChange] || [], actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            callBackFunct && callBackFunct();
        }
    };
    const timeOutFunct = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
        toast.error(t('error.time_out'));
    };
    return (
        <div>
            <Dialog open={visible} onClose={() => setVisible(false)} aria-labelledby="draggable-dialog-title">
                <Loader loading={loading || flagProcess} />
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {title ? t(title) : t('info')}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            style={{ width: '100%', gap: 10, display: 'flex', flexDirection: 'column', minWidth: 350 }}
                            xl={12}
                            md={12}
                            sm={12}
                        >
                            <DialogContentText>{mesages ? t(mesages) : t('message')}</DialogContentText>
                            <TextField
                                label={t('noteReturn')}
                                valueChange={noteChange}
                                size="medium"
                                required
                                onEnterPress={handleConfirm}
                                onChange={(ele) => setNoteChange(ele.currentTarget.value)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: '12px 16px' }}>
                    <ButtonAction
                        title={t('cancel')}
                        onClick={() => setVisible(false)}
                        // variant="text"
                        color="error"
                        type="cancel"
                    />
                    <ButtonAction
                        title={t(titleButtonConfirm)}
                        type={typeButtonConfirm}
                        onClick={handleDelete || handleConfirm}
                    />
                </DialogActions>
            </Dialog>
        </div>
    );
}
